import { render, staticRenderFns } from "./solutionDetails.vue?vue&type=template&id=1ee37d84&scoped=true&"
import script from "./solutionDetails.vue?vue&type=script&lang=js&"
export * from "./solutionDetails.vue?vue&type=script&lang=js&"
import style0 from "./solutionDetails.vue?vue&type=style&index=0&id=1ee37d84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee37d84",
  null
  
)

export default component.exports